/**
 * Capacitor storage adapter para Supabase auth.
 *
 * Em plataforma nativa (iOS/Android): usa @capacitor/preferences, que persiste
 * no Keychain (iOS) / Keystore (Android). Quando os 2 apps nativos compartilham
 * Team ID (iOS) + App Groups ou mesma keystore (Android), a sessão é
 * compartilhada entre eles — habilitando SSO nativo↔nativo per ADR-0001.
 *
 * Em plataforma web (ex: vite dev): cai automaticamente pra localStorage.
 *
 * Requer peer deps `@capacitor/core` e `@capacitor/preferences`.
 */
import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";
import type { AuthStorage } from "../types";
import { webStorage } from "./web";

export const capacitorStorage: AuthStorage = {
  getItem: async (key: string): Promise<string | null> => {
    if (Capacitor.isNativePlatform()) {
      const { value } = await Preferences.get({ key });
      return value;
    }
    return webStorage.getItem(key);
  },

  setItem: async (key: string, value: string): Promise<void> => {
    if (Capacitor.isNativePlatform()) {
      await Preferences.set({ key, value });
      return;
    }
    return webStorage.setItem(key, value) as void;
  },

  removeItem: async (key: string): Promise<void> => {
    if (Capacitor.isNativePlatform()) {
      await Preferences.remove({ key });
      return;
    }
    return webStorage.removeItem(key) as void;
  },
};
